import { IModel, Model } from '@common/models/Model';

export interface IReminderDeactivationReasonModel extends IModel {
  reminderDeactivationReasonId: number;
  name: string;
}

export class ReminderDeactivationReasonModel
  extends Model
  implements IReminderDeactivationReasonModel
{
  reminderDeactivationReasonId: number;
  name: string;

  constructor(params: Partial<IReminderDeactivationReasonModel>) {
    super(params);

    this.reminderDeactivationReasonId = _.defaultTo(
      params?.reminderDeactivationReasonId,
      0,
    );
    this.name = _.defaultTo(params.name, '');
  }
}
